export default {"src":"/_next/static/media/orientation.7deb4f8d.svg","height":66,"width":469};